import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CompaniesService} from '../../../services/modules/companies.service';

interface OvertimeRefRow {
  label: string;
  defaultCode: string;
  key: string;
}

@Component({
  selector: 'app-dialog-referencestypes-overtime',
  templateUrl: './dialog-referencestypes-overtime.component.html',
  styleUrls: ['./dialog-referencestypes-overtime.component.scss']
})

export class DialogReferencestypesOvertimeComponent implements OnInit {
  configReferencesTypesOvertimeForm: FormGroup;

  private readonly rows: OvertimeRefRow[] = [
    { label: 'Horas ordinarias diurnas',            defaultCode: 'HOD',  key: 'hod'  },
    { label: 'Horas ordinarias nocturnas',          defaultCode: 'HON',  key: 'hon'  },
    { label: 'Horas extra diurnas',                 defaultCode: 'HED',  key: 'hed'  },
    { label: 'Horas extra nocturnas',               defaultCode: 'HEN',  key: 'hen'  },
    { label: 'Horas ordinarias dominicales diurnas', defaultCode: 'HODD', key: 'hodd' },
    { label: 'Horas ordinarias dominicales nocturnas', defaultCode: 'HODN', key: 'hodn' },
    { label: 'Horas extra dominicales diurnas',     defaultCode: 'HEDD', key: 'hedd' },
    { label: 'Horas extra dominicales nocturnas',   defaultCode: 'HEDN', key: 'hedn' },
  ];

  constructor(
    public dialogRef: MatDialogRef<DialogReferencestypesOvertimeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { companyId: string },
    private fb: FormBuilder,
    private companiesServices: CompaniesService,
  ) {
    this.configReferencesTypesOvertimeForm = this.fb.group({
      items: this.fb.array([])
    });
  }

  ngOnInit(): void {
    this.buildForm();
    this.loadData();
  }

  get items(): FormArray {
    return this.configReferencesTypesOvertimeForm.get('items') as FormArray;
  }

  private buildForm(): void {
    this.rows.forEach(r => {
      const group = this.fb.group({
        label: [{ value: r.label, disabled: true }],
        key: [r.key],
        code: [
          r.defaultCode,
          [
            Validators.required,
            Validators.maxLength(10),
            Validators.pattern(/^[A-Za-z0-9]{1,10}$/)
          ]
        ]
      });

      const codeCtrl = group.get('code');
      if (!codeCtrl) { return; }

      codeCtrl.valueChanges.subscribe(v => {
        if (typeof v === 'string') {
          const upper = v.toUpperCase();
          if (upper !== v) {
            codeCtrl.setValue(upper, { emitEvent: false });
          }
        }
      });

      this.items.push(group);
    });
  }

  private loadData(): void {
    const adminInfoId = this.data?.companyId;
    if (!adminInfoId) {
      return;
    }

    this.companiesServices.getReferencesTypesOvertime(adminInfoId).subscribe({next: (resp: any) => {
          const data = Array.isArray(resp) ? resp[0] : resp;

          if (!data) { return; }
          this.items.controls.forEach((grp, index) => {
            const fieldName = this.rows[index].defaultCode;
            const value = data[fieldName];

            if (value) {
              grp.get('code')?.setValue(value);
            }
          });
        },
        error: (err) => {
        }
      });
  }

  onCodeInput(index: number): void {
    const grp = this.items.at(index) as FormGroup;
    const ctrl = grp.get('code');
    const raw = (ctrl?.value || '') as string;
    const sanitized = raw.replace(/[^A-Za-z0-9]/g, '').toUpperCase().slice(0, 10);
    if (sanitized !== raw) { ctrl?.setValue(sanitized, { emitEvent: true }); }
  }

  save(): void {
    if (this.configReferencesTypesOvertimeForm.invalid) {
      this.configReferencesTypesOvertimeForm.markAllAsTouched();
      return;
    }

    const adminInfoId = this.data?.companyId;
    const model = {
      AdminInfoId: adminInfoId,
      HOD: '',
      HON: '',
      HED: '',
      HEN: '',
      HODD: '',
      HODN: '',
      HEDD: '',
      HEDN: ''
    };

    this.items.controls.forEach((grp, index) => {
      const prop = this.rows[index].defaultCode as keyof typeof model;
      const value = grp.get('code')?.value || '';
      model[prop] = value;
    });

    this.companiesServices.postReferencesTypesOvertime(model).subscribe({
      next: () => {
        this.dialogRef.close(true);
      },
      error: (err) => {
      }
    });
  }

  close(): void {
    this.dialogRef.close(false);
  }

}
